module.exports = __webpack_public_path__ + "static/img/course1.9ac05bec.png";